import { uniq } from 'es-toolkit';
import React from 'react';
import { Checkbox, Divider, FormControlLabel, Stack } from '@mui/material';

import { allHangerHardware, HangerList, StandardConnectingHardwareModel } from '@paragon/contract-library';
import { getConnectingHardwareName } from '@paragon/material-lists';

interface HangerListTableProps {
  readonly hangerList: HangerList;
  readonly setEditedHangerList: (hangerList: HangerList) => void;
}

export function HangerListTable(props: HangerListTableProps) {
  const allSelected = allHangerHardware.every((hangerHardwareFromCompleteList) =>
    props.hangerList.hangerHardware.includes(hangerHardwareFromCompleteList),
  );
  const someSelected = allHangerHardware.some((hangerHardwareFromCompleteList) =>
    props.hangerList.hangerHardware.includes(hangerHardwareFromCompleteList),
  );

  function updateHangerHardware(hangerHardware: readonly StandardConnectingHardwareModel[]) {
    props.setEditedHangerList({
      ...props.hangerList,
      hangerHardware,
    });
  }

  function checkBoxForHangerHardware(hangerHardware: StandardConnectingHardwareModel) {
    return (
      <FormControlLabel
        key={hangerHardware}
        control={
          <Checkbox
            checked={props.hangerList.hangerHardware.includes(hangerHardware)}
            onChange={(event) =>
              void updateHangerHardware(
                event.target.checked
                  ? uniq([...props.hangerList.hangerHardware, hangerHardware])
                  : props.hangerList.hangerHardware.filter(
                      (existingHangerHardware) => existingHangerHardware !== hangerHardware,
                    ),
              )
            }
          />
        }
        label={getConnectingHardwareName(hangerHardware)}
      />
    );
  }

  return (
    <Stack spacing={1} sx={{ mx: 2 }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={allSelected}
            indeterminate={allSelected ? false : someSelected}
            onChange={() => void updateHangerHardware(allSelected ? [] : allHangerHardware)}
          />
        }
        label="Select All"
      />
      <Divider />
      {allHangerHardware.map((hangerHardwareFromCompleteList) =>
        checkBoxForHangerHardware(hangerHardwareFromCompleteList),
      )}
    </Stack>
  );
}
